import {Component} from "@angular/core";

interface Message {
  text: string;
}

@Component({
  selector: "common-i18npluralpipe",
  template: `
  <usecase-container title="I18nPluralPipe" src="common/i18npluralpipe">
    <usecase-content>
      <p>{{messages.length | i18nPlural: lengthMessageMapping}}</p>
      <form #f="ngForm">
        <input type="text" ngControl="text" required>
        <button [attr.disabled]="f.valid?null:true" (click)="add(f.value.text);">Add</button>
      </form>
      <ul>
        <li *ngFor="let message of messages">{{message.text}}</li>
      </ul>
      <button (click)="reset()">Reset</button>
    </usecase-content>
  </usecase-container>
    `,
})
export class I18nPluralPipeComponent {
  private lengthMessageMapping: any = {
    "=0": "No messages.",
    "=1": "One message.",
    "other": "# messages."
  };
  private messages: Message[] = [];

  add(text: string) {
    if (text) {
      this.messages.push({ text: text });
    }
  }

  reset() {
    this.messages = [];
  }
}



/** WEBPACK FOOTER **
 ** ./script/common/i18npluralpipe/component.ts
 **/